import { File, Settings } from "react-feather";

let menuText = localStorage.getItem("menu")
let menuJSON = JSON.parse(menuText)
let menuList = []

if(menuJSON != null){
    let menuSettings = menuJSON.filter((item) => item.label == 'Pengaturan')
    if (menuSettings[0] !== undefined) {
        if (menuSettings[0].children != undefined || menuSettings[0].children != null) {
            menuSettings[0].children.map((item) => {
                if (item.label === 'Wilayah (Satuan Kerja)') {
                    menuList.push({
                        id: "m-setting-wilayah",
                        title: "Wilayah",
                        navLink: "/settings/wilayah"
                    })
                } else if (item.label === 'Role') {
                    menuList.push({
                        id: "m-setting-role",
                        title: "Role",
                        navLink: "/settings/role"
                    })
                } else if (item.label === 'User') {
                    menuList.push({
                        id: "m-setting-user",
                        title: "User",
                        navLink: "/settings/user"
                    })
                } else if (item.label === 'Formula') {
                    menuList.push({
                        id: "m-setting-formula",
                        title: "Formula",
                        navLink: "/settings/formula"
                    })
                } else if (item.label === 'Informasi & Bantuan') {
                    menuList.push({
                        id: "m-setting-info",
                        title: "Info Bantuan",
                        navLink: "/settings/info"
                    })
                } else if (item.label === 'Dashboard') {
                    menuList.push({
                        id: "m-setting-dashboard",
                        title: "Dashboard",
                        navLink: "/settings/dashboard"
                    })
                }
            })
        }
    }
}



export default [
    {
        id: "m-settings",
        title: "Pengaturan",
        icon: <Settings size={20} />,
        children: menuList
    },

]
